import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { DiscountRetrieve, ErrorMessage, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseDiscountByCodeProps {
  code: string;
  athleteId?: string;
  productId?: string;
  salesPortalGym?: string;
}

function useDiscountByCode({
  code,
  athleteId,
  productId,
  salesPortalGym,
}: IUseDiscountByCodeProps): UseQueryResult<AxiosResponse<DiscountRetrieve>, AxiosError<ErrorMessage>> {
  const lookupDiscount = (): Promise<AxiosResponse<DiscountRetrieve>> => {
    const params: UrlParams = { code };
    if (athleteId) {
      params.athlete_id = athleteId;
    }
    if (productId) {
      params.product_id = productId;
    }

    const path = salesPortalGym
      ? `sales-portal/gyms/${salesPortalGym}/discounts/lookup/`
      : 'discounts/lookup/';

    return client.get(`${path}?${encodeUrlParams(params)}`);
  };

  return useQuery(['discounts', 'lookup', { code, athleteId, productId, salesPortalGym }], lookupDiscount, {
    enabled: false,
    retry: false,
  });
}

export default useDiscountByCode;
